<template>
  <div>
    <div class="father">
          <div>
            <h1>Main heading</h1>
            <h2>Sub heading</h2>
          </div>
          <div>
            <article>
              <img src="../../../static/img/管理-1.jpg" />
              <h2></h2>
              <div class="content_div">
                <h3>食品安全管理</h3>
                <div class="litter_line"></div>
                <p>
                  严格按照
                  ISO22000：2005食品安全管理体系认证对物资采购、验收进行严苛的管理：
                </p>
                <p>
                  1.
                  对所有供应商资质进行严格审核，与合格供应商签订供应商合同，并建立供应商管理档案。
                </p>
                <p>
                  2.
                  供应商必须提供合法证件，产品必须由检验合格证明，保证食材的可追溯性。
                </p>
                <p>
                  3. 按日期填写伙食原材料验收单。拒收质量不佳物资及“三无产品”。
                </p>
              </div>
            </article>
            <article>
              <h2></h2>
              <img src="../../../static/img/管理-2.jpg" />
              <div class="content_div">
                <h3>食品卫生管理</h3>
                <div class="litter_line"></div>
                <p>
                  严格执行ISO9001：2015质量管理体系，在食品卫生管理上，建立了一整套卫生管理体系。
                </p>
                <p>
                  从原料采购、加工、烹饪、销售到原料贮存，都有科学、完善的操作制度和检查制度，注重加工过程中的质量控制，确保出品卫生符合要求。
                </p>
              </div>
            </article>
            <article>
              <h2></h2>
              <img src="../../../static/img/管理-3.jpg" />
              <div class="content_div">
                <h3>食品质量管理</h3>
                <div class="litter_line"></div>
                <p>
                  坚决做到不买不验收，不使用变质、过期的原料和食品；建立台账制度，采购发票佐证便于追溯源头。饭菜48小时留样，保障企业员工的身体健康及合法权益。
                </p>
              </div>
            </article>
            <article>
              <h2></h2>
              <img src="../../../static/img/管理-4.jpg" />
              <div class="content_div">
                <h3>人才素质管理</h3>
                <div class="litter_line"></div>
                <p>
                  所有人员均经过严格的筛选后方可聘用，上岗前经过多轮严格的岗位培训和操作流程制度培训，确保服务团队的高品质，为企业、单位提供放心、满意、优质的餐饮服务。
                </p>
              </div>
            </article>
            <article>
              <h2></h2>
              <img src="../../../static/img/管理-5.jpeg" />
              <div class="content_div">
                <h3>成本控制管理</h3>
                <div class="litter_line"></div>
                <p>
                  对供应商制定了严格的质量与价格评选标准，对大宗食材联合采购，相比于二三级市场采购商有着绝对的成本优势，并与蔬菜基地、米面粮油等一级代理商直接签订了供销合同，大大降低了采购成本，助力企业后勤成本控制。
                </p>
              </div>
            </article>
            <article>
              <h2></h2>
              <img src="../../../static/img/管理-6.jpg" />
              <div class="content_div">
                <h3>紧急事故管理</h3>
                <div class="litter_line"></div>
                <p>
                  注重餐厅的日常安全，配备灭火器等紧急处理设备，由专人定期检查保养；订立事故应急预案，针对预案内容，每半年进行一次演练，如食物中毒预案演练、消防演练等。
                </p>
              </div>
            </article>
          </div>
        </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  computed: {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>
<style lang="stylus" scoped>
.father {
  width: 100%;
  height: 50rem;
  margin: 5rem auto;

.litter_line {
  display: inline-block;
  margin: 5rem 5rem 3rem 5rem;
  background-color: white;
  height: 1px;
  width: 20% !important;
}

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  * {
    transition: all 0.3s ease 0s;
  }

  .content_div {
    height: 100%;
    width: 100%;
    background: var(--textBlue60);
    position: absolute;
    top: 0;

    h3 {
      margin: 5rem 0 0 5rem;
      font-size: 3.2rem;
      font-family: bold;
    }

    p {
      margin: 0 5rem 0 5rem;
      width: auto;
            font-size: 1.8rem;
      font-family:light;
      line-height: 3rem;
    }

    .first_p {
      margin: 5rem 5rem 0 5rem;
    }
  }

  /* Background colours */
  div + div article:nth-child(1) {
    // background: #00c22326;
    // background-image: url('../../static/img/切片-38.jpg');
    background-repeat: no-repeat;
  }

  div + div article:nth-child(2) {
    // background: #f37338;
    // background-image: url('../../static/img/切片-39.jpg');
  }

  div + div article:nth-child(3) {
    // background: #fdb632;
    // background-image: url('../../static/img/切片-40.jpg');
  }

  div + div article:nth-child(4) {
    // background: #027878;
    // background-image: url('../../static/img/切片-41.jpg');
  }

  div + div article:nth-child(5) {
    // background: #801638;
    // background-image: url('../../static/img/切片-42.jpg');
  }

  div + div article:nth-child(6), div + div {
    // background: #800000;
    // background-image: url('../../static/img/切片-43.jpg');
    // height:100%;
    // background-repeat: no-repeat;
  }

  /* Main layout */
  html, body, div + div {
    width: 100%;
    height: 100%;
  }

  div + div {
    list-style: none;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;
    overflow: hidden;
  }

  /* Articles */
  div + div article {
    flex: initial;
    width: 17%;
    height: 100%;
    text-align: center;
    color: #fff;
    text-decoration: none;
    vertical-align: bottom;
    box-sizing: border-box;
    // padding: 2vh 1vw;
    position: relative;
  }

  /* Big Headings */
  div:first-child {
    display: none;
    position: fixed;
    bottom: 8vh;
    background: #fff;
    width: 100%;
    text-align: center;
    padding: 0.5rem;
    z-index: 2;
  }

  div:first-child h1, div:first-child h2 {
    margin: 0;
    padding: 0;
  }

  /* Hover interaction */
  div + div:hover article {
    flex: initial;
    width: 10%;
  }

  div + div article:hover {
    width: 50%;
  }

  article > div {
    opacity: 0;
    transition: opacity 0.2s ease 0;
  }

  div + div article:hover > div {
    opacity: 1;
    transition: opacity 0.3s ease 0.3s;
  }

  /* navigation */
  div + div article > h2 {
    bottom: 2vh;
    position: absolute;
    text-align: center;
    width: 100%;
    margin: 0;
    font-size: 3vh;
  }

  /* Article layouts */
  article div {
    text-align: left;
    width: 58vw;
  }

  article div p, article div div h2, article div h3 {
    margin: 0 0 1em 0;
  }

  h1, h2, h3, h4, h5, h6 {
    text-transform: uppercase;
  }

  article div p {
    width: 40vw;
  }

  @media (max-width: 900px) {
    div + div article {
      padding: 2vh 3vw;
    }

    div + div article > h2 {
      transform: rotate(90deg);
      bottom: 23vh;
      min-width: 12em;
      text-align: left;
      transform: rotate(-90deg);
      transform-origin: 0 0 0;
      opacity: 1;
    }

    div + div article:hover > h2 {
      opacity: 0;
    }

    article div p {
      width: 50vw;
    }

    article div {
      max-height: calc(72%);
      overflow-y: auto;
    }
  }
}
</style>